module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_23.a583bf61.pdf";